// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/storefront/v1/page_theme.proto (package kitecorp.transferify.storefront.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { BackdropOptions, BackdropTemplate } from "./backdrop_pb";
import { file_kitecorp_transferify_storefront_v1_backdrop } from "./backdrop_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/storefront/v1/page_theme.proto.
 */
export const file_kitecorp_transferify_storefront_v1_page_theme: GenFile = /*@__PURE__*/
  fileDesc("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", [file_kitecorp_options_v1_options, file_kitecorp_transferify_storefront_v1_backdrop]);

/**
 * One picture of the library.
 *
 * @generated from message kitecorp.transferify.storefront.v1.ThemeImage
 */
export type ThemeImage = Message<"kitecorp.transferify.storefront.v1.ThemeImage"> & {
  /**
   * The picture's id, a UUID.
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;

  /**
   * The address of the picture, served to every recipient without a session.
   *
   * @generated from field: string image_url = 2;
   */
  imageUrl: string;

  /**
   * Whether the saved theme shows this picture.
   *
   * @generated from field: bool attached = 3;
   */
  attached: boolean;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.ThemeImage.
 * Use `create(ThemeImageSchema)` to create a new message.
 */
export const ThemeImageSchema: GenMessage<ThemeImage> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 0);

/**
 * The theme of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.PageTheme
 */
export type PageTheme = Message<"kitecorp.transferify.storefront.v1.PageTheme"> & {
  /**
   * Whether recipients see the theme.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * The treatment. Unspecified while no theme is saved.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.BackdropTemplate template = 2;
   */
  template: BackdropTemplate;

  /**
   * The treatment's options.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.BackdropOptions options = 3;
   */
  options?: BackdropOptions | undefined;

  /**
   * The whole picture library, in library order.
   *
   * @generated from field: repeated kitecorp.transferify.storefront.v1.ThemeImage images = 4;
   */
  images: ThemeImage[];
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.PageTheme.
 * Use `create(PageThemeSchema)` to create a new message.
 */
export const PageThemeSchema: GenMessage<PageTheme> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 1);

/**
 * Asks for the theme of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.GetPageThemeRequest
 */
export type GetPageThemeRequest = Message<"kitecorp.transferify.storefront.v1.GetPageThemeRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.GetPageThemeRequest.
 * Use `create(GetPageThemeRequestSchema)` to create a new message.
 */
export const GetPageThemeRequestSchema: GenMessage<GetPageThemeRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 2);

/**
 * The theme of the signed-in account.
 *
 * @generated from message kitecorp.transferify.storefront.v1.GetPageThemeResponse
 */
export type GetPageThemeResponse = Message<"kitecorp.transferify.storefront.v1.GetPageThemeResponse"> & {
  /**
   * The theme, with the whole library.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.PageTheme theme = 1;
   */
  theme?: PageTheme | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.GetPageThemeResponse.
 * Use `create(GetPageThemeResponseSchema)` to create a new message.
 */
export const GetPageThemeResponseSchema: GenMessage<GetPageThemeResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 3);

/**
 * Saves the theme.
 *
 * @generated from message kitecorp.transferify.storefront.v1.SetPageThemeRequest
 */
export type SetPageThemeRequest = Message<"kitecorp.transferify.storefront.v1.SetPageThemeRequest"> & {
  /**
   * The treatment. A video treatment is refused.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.BackdropTemplate template = 1;
   */
  template: BackdropTemplate;

  /**
   * The treatment's options. Which options a treatment takes is the server's rule.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.BackdropOptions options = 2;
   */
  options?: BackdropOptions | undefined;

  /**
   * Whether recipients see the theme.
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * The ids of the library pictures to show (UUIDs), in render order.
   *
   * @generated from field: repeated string asset_ids = 4;
   */
  assetIds: string[];
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.SetPageThemeRequest.
 * Use `create(SetPageThemeRequestSchema)` to create a new message.
 */
export const SetPageThemeRequestSchema: GenMessage<SetPageThemeRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 4);

/**
 * The theme after the change.
 *
 * @generated from message kitecorp.transferify.storefront.v1.SetPageThemeResponse
 */
export type SetPageThemeResponse = Message<"kitecorp.transferify.storefront.v1.SetPageThemeResponse"> & {
  /**
   * The theme as stored.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.PageTheme theme = 1;
   */
  theme?: PageTheme | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.SetPageThemeResponse.
 * Use `create(SetPageThemeResponseSchema)` to create a new message.
 */
export const SetPageThemeResponseSchema: GenMessage<SetPageThemeResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 5);

/**
 * Asks to remove the saved theme.
 *
 * @generated from message kitecorp.transferify.storefront.v1.ResetPageThemeRequest
 */
export type ResetPageThemeRequest = Message<"kitecorp.transferify.storefront.v1.ResetPageThemeRequest"> & {
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.ResetPageThemeRequest.
 * Use `create(ResetPageThemeRequestSchema)` to create a new message.
 */
export const ResetPageThemeRequestSchema: GenMessage<ResetPageThemeRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 6);

/**
 * The theme after the reset.
 *
 * @generated from message kitecorp.transferify.storefront.v1.ResetPageThemeResponse
 */
export type ResetPageThemeResponse = Message<"kitecorp.transferify.storefront.v1.ResetPageThemeResponse"> & {
  /**
   * The theme, with the library that stays.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.PageTheme theme = 1;
   */
  theme?: PageTheme | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.ResetPageThemeResponse.
 * Use `create(ResetPageThemeResponseSchema)` to create a new message.
 */
export const ResetPageThemeResponseSchema: GenMessage<ResetPageThemeResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 7);

/**
 * Names the picture to delete.
 *
 * @generated from message kitecorp.transferify.storefront.v1.DeleteThemeImageRequest
 */
export type DeleteThemeImageRequest = Message<"kitecorp.transferify.storefront.v1.DeleteThemeImageRequest"> & {
  /**
   * The picture's id, a UUID.
   *
   * @generated from field: string asset_id = 1;
   */
  assetId: string;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.DeleteThemeImageRequest.
 * Use `create(DeleteThemeImageRequestSchema)` to create a new message.
 */
export const DeleteThemeImageRequestSchema: GenMessage<DeleteThemeImageRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 8);

/**
 * The theme after the deletion.
 *
 * @generated from message kitecorp.transferify.storefront.v1.DeleteThemeImageResponse
 */
export type DeleteThemeImageResponse = Message<"kitecorp.transferify.storefront.v1.DeleteThemeImageResponse"> & {
  /**
   * The theme, with the library that remains.
   *
   * @generated from field: kitecorp.transferify.storefront.v1.PageTheme theme = 1;
   */
  theme?: PageTheme | undefined;
};

/**
 * Describes the message kitecorp.transferify.storefront.v1.DeleteThemeImageResponse.
 * Use `create(DeleteThemeImageResponseSchema)` to create a new message.
 */
export const DeleteThemeImageResponseSchema: GenMessage<DeleteThemeImageResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_storefront_v1_page_theme, 9);

/**
 * The theme of the page a sender's recipients open to download (kitecorp/contracts#74): a backdrop treatment, its
 * options and the pictures it shows. Each call reads or changes the theme of the signed-in account.
 *
 * @generated from service kitecorp.transferify.storefront.v1.PageThemeService
 */
export const PageThemeService: GenService<{
  /**
   * Reads the theme and the whole picture library of the signed-in account.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.PageThemeService.GetPageTheme
   */
  getPageTheme: {
    methodKind: "unary";
    input: typeof GetPageThemeRequestSchema;
    output: typeof GetPageThemeResponseSchema;
  },
  /**
   * Saves the theme: the treatment, its options, whether it is on, and the pictures in render order.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.PageThemeService.SetPageTheme
   */
  setPageTheme: {
    methodKind: "unary";
    input: typeof SetPageThemeRequestSchema;
    output: typeof SetPageThemeResponseSchema;
  },
  /**
   * Removes the saved theme. The pictures stay in the library.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.PageThemeService.ResetPageTheme
   */
  resetPageTheme: {
    methodKind: "unary";
    input: typeof ResetPageThemeRequestSchema;
    output: typeof ResetPageThemeResponseSchema;
  },
  /**
   * Deletes one picture from the library. A picture the theme shows while it is switched on is refused; a
   * switched-off theme's pictures can be deleted.
   *
   * @generated from rpc kitecorp.transferify.storefront.v1.PageThemeService.DeleteThemeImage
   */
  deleteThemeImage: {
    methodKind: "unary";
    input: typeof DeleteThemeImageRequestSchema;
    output: typeof DeleteThemeImageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_storefront_v1_page_theme, 0);

